import React from "react";
import { useSelector } from "react-redux";
import { Button } from "../../../../components";
import { getSelfServiceCnameSelector } from "../../../../store/selfServiceSlice";
import { useHandlers } from "./hooks";
import { AddProductModal } from "./components";

/**
 * @desc Add New Product CTA.
 */
export const AddProductButton = () => {
  const cname = useSelector(getSelfServiceCnameSelector);
  const { onAddProduct } = useHandlers();

  // COMPONENT ----------------------------------------------------------------

  const addProductButtonProps = {
    disabled: !cname,
    children: "ADD PRODUCT",
    className: "funko-blue",
    onClick: onAddProduct,
  };

  return (
    <>
      <AddProductModal />
      <Button {...addProductButtonProps} />
    </>
  );
};

export default AddProductButton;
